import { render } from "./Folders.vue?vue&type=template&id=d2c042e0&scoped=true&ts=true&lang=pug"
import script from "./Folders.vue?vue&type=script&lang=ts"
export * from "./Folders.vue?vue&type=script&lang=ts"

import "./Folders.vue?vue&type=style&index=0&id=d2c042e0&scoped=true&lang=css"

import exportComponent from "/var/www/html/platform-frontend/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-d2c042e0"]])

export default __exports__